import { MDBBtn, MDBCheckbox, MDBCol, MDBInput, MDBRadio, MDBRow, MDBSpinner } from "mdb-react-ui-kit";
import { useState } from "react";
import Select from 'react-select';
import BranchSelect from "../../Components/CMS/BranchSelect";
import ImageUploader from "../../Components/ImageUploader/ImageUploader";
import { useEffect } from "react";
import { validateForm } from "../../Utils/utils";
import ApiService from "../../Core/Service/ApiService";

let timer1 = null;

const CategoryEdit = (props) => {
    const csbOptions = [
        { value: 'c', label: 'C' },
        { value: 's', label: 'S' },
        { value: 'b', label: 'B' },
    ]
    const [formData, setFormData] = useState({})
    const [inputErrors, setInputErrors] = useState({});
    const rules = {
        category_name: {
            required: 'string'
        }
    }
    const [saving, setSaving] = useState(false);
    const [marginTop, setMarginTop] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            if (timer1) clearTimeout(timer1);

            timer1 = setTimeout(() => {
                setMarginTop(Math.max(window.scrollY - 100, 0));
            }, 500);
        };
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [])

    useEffect(() => {
        setFormData({ ...(props.category ?? {}) });
    }, [props.category])

    const handleInputChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        })
    }
    const handleCheckChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.checked ? 1 : 0,
        })
    }
    const handleSelectChange = (opt, name) => {
        setFormData({
            ...formData,
            [name]: opt.value,
        })
    }
    const handleBranchChange = (branches) => {
        setFormData({
            ...formData,
            branches
        })
    }
    const handleLogoLinkTypeChange = async (e, target, link_type) => {
        setFormData({
            ...formData,
            [target]: {
                ...formData[target],
                active_link: link_type
            }
        })
    }
    const handleLogoExternalLinkChange = async (e, target) => {
        setFormData({
            ...formData,
            [target]: {
                ...formData[target],
                external_link: e.target.value
            }
        })
    }
    const onImageUploaded = async (target, upload_file) => {
        setFormData({
            ...formData,
            [target]: {
                ...formData[target],
                upload_file: upload_file
            }
        });
    }
    const onImageDeleted = async (target) => {
        setFormData({
            ...formData,
            [target]: {
                ...formData[target],
                upload_file: ''
            }
        })
    }

    useEffect(() => {
        const ret = validateForm(formData, rules);
        setInputErrors(ret);
    }, [formData]);

    const handleSave = () => {
        const ret = validateForm(formData, rules);
        setInputErrors(ret);

        if (ret.result) {
            setSaving(true);

            const data = {
                ...formData,
                branches: formData.branches?.join(','),
                logo_web: JSON.stringify(formData.logo_web),
                logo_mobile: JSON.stringify(formData.logo_mobile),
            }

            ApiService.put(`/categories/${formData.category_id}`, data).then(response => {
                props.onCategoryUpdated && props.onCategoryUpdated(formData);
            }).finally(() => {
                setSaving(false);
            })
        }
    }

    return (
        <div className={`category-edit ${props.className}`} style={{ marginTop: marginTop }} key={formData.category_id ?? ''}>
            <MDBRow className="w-100">
                <MDBCol lg={6} xl={4} className="mb-4">
                    <label className="required">Category Name:</label>
                    <MDBInput name='category_name' value={formData.category_name ?? ''} onChange={handleInputChange} />
                </MDBCol>
                <MDBCol lg={6} xl={4} className="mb-4">
                    <label>Filter Description:</label>
                    <MDBInput name='filter_desc' value={formData.filter_desc ?? ''} onChange={handleInputChange} />
                </MDBCol>
                <MDBCol lg={6} xl={4} className="mb-4">
                    <label>Alias:</label>
                    <MDBInput name='alias' value={formData.alias ?? ''} onChange={handleInputChange} />
                </MDBCol>
                <MDBCol lg={6} xl={4} className="mb-4">
                    <label>Type:</label>
                    <MDBInput name='type' value={formData.type ?? ''} onChange={handleInputChange} />
                </MDBCol>
                <MDBCol lg={4} xl={2} className="mb-4">
                    <label>Import:</label>
                    <MDBInput name='import' value={formData.import ?? ''} readOnly />
                </MDBCol>
                <MDBCol lg={4} xl={2} className="mb-4">
                    <label>C or S, B</label>
                    <Select
                        options={csbOptions}
                        value={csbOptions.find(opt => opt.value == formData.c_or_s_b)}
                        onChange={opt => handleSelectChange(opt, 'c_or_s_b')}
                    />
                </MDBCol>
                <MDBCol lg={4} xl={2} className="mb-4" style={{ paddingTop: 30 }}>
                    <MDBCheckbox name='display' checked={formData.display == 1} label="Display" onChange={handleCheckChange} />
                </MDBCol>
            </MDBRow>

            <MDBRow>
                <BranchSelect
                    className="mt-4"
                    initialSelectedBranches={formData.branches}
                    onChange={handleBranchChange}
                    required={true}
                    inputError={inputErrors?.branches}
                />
            </MDBRow>

            <MDBRow className="mt-4">
                <div className="d-flex align-items-center mt-4">
                    <div className="flex-fluid">
                        <label className="d-flex align-items-center">Logo (Web):</label>
                        <div className="mt-2">
                            <div>
                                <MDBRadio
                                    label='External Link'
                                    checked={formData.logo_web?.active_link == 'external'}
                                    onChange={(e) => handleLogoLinkTypeChange(e, 'logo_web', 'external')}
                                />
                                <MDBInput
                                    className={formData.logo_web?.active_link == 'external' ? '' : 'disabled'}
                                    value={formData.logo_web?.external_link ?? ''}
                                    onChange={e => handleLogoExternalLinkChange(e, 'logo_web')}
                                />
                            </div>
                            <div className="mt-2">
                                <MDBRadio
                                    label='Upload Logo'
                                    checked={formData.logo_web?.active_link == 'upload'}
                                    onChange={(e) => handleLogoLinkTypeChange(e, 'logo_web', 'upload')}
                                />
                                <ImageUploader
                                    id='logo_web'
                                    className={formData.logo_web?.active_link == 'upload' ? '' : 'disabled'}
                                    onImageUploaded={onImageUploaded}
                                    onImageDeleted={onImageDeleted}
                                    defaultSrc={formData.logo_web?.upload_file ?? ''}
                                    folder="web"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="ms-4 flex-fluid">
                        <label className="d-flex align-items-center">Logo (Mobile):</label>
                        <div className="mt-2">
                            <div>
                                <MDBRadio
                                    label='External Link'
                                    checked={formData.logo_mobile?.active_link == 'external'}
                                    onChange={(e) => handleLogoLinkTypeChange(e, 'logo_mobile', 'external')}
                                />
                                <MDBInput
                                    className={formData.logo_mobile?.active_link == 'external' ? '' : 'disabled'}
                                    value={formData.logo_mobile?.external_link ?? ''}
                                    onChange={e => handleLogoExternalLinkChange(e, 'logo_mobile')}
                                />
                            </div>
                            <div className="mt-2">
                                <MDBRadio
                                    label='Upload Logo'
                                    checked={formData.logo_mobile?.active_link == 'upload'}
                                    onChange={e => handleLogoLinkTypeChange(e, 'logo_mobile', 'upload')}
                                />
                                <ImageUploader
                                    id='logo_mobile'
                                    className={formData.logo_mobile?.active_link == 'upload' ? '' : 'disabled'}
                                    onImageUploaded={onImageUploaded}
                                    onImageDeleted={onImageDeleted}
                                    defaultSrc={formData.logo_mobile?.upload_file ?? ''}
                                    folder="mobile"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </MDBRow>

            <div className="mt-4 d-flex justify-content-end">
                <MDBBtn color="primary" onClick={handleSave} disabled={!formData.category_id}>
                    {saving && <MDBSpinner className="me-1" size="sm" />}
                    Save
                </MDBBtn>
            </div>
        </div>
    )
}

export default CategoryEdit;